import type { User } from '../types/auth'

/**
 * Admin configuration
 *
 * To add admin access:
 * 1. Set environment variable: VUE_APP_ADMIN_EMAILS=your.email@example.com,another@example.com
 * 2. Or add your email directly in the ADMIN_EMAILS array below (for development)
 *
 * Note: Multiple emails can be separated by commas in the env var
 */
const ADMIN_EMAILS_FROM_ENV = (process.env.VUE_APP_ADMIN_EMAILS || '').split(',').filter(Boolean)

// Add your email here for development (remove before committing sensitive info)
const HARDCODED_ADMIN_EMAILS: string[] = [
  // Add your email here, e.g.:
  'abhishek.powar@gohighlevel.com'
  // 'naman@gohighlevel.com' -> disabled until we have a proper admin role in authentik
]

/**
 * Combined list of admin emails from environment and hardcoded sources
 */
const ADMIN_EMAILS = [...ADMIN_EMAILS_FROM_ENV, ...HARDCODED_ADMIN_EMAILS]
  .map((email) => email.toLowerCase().trim())
  .filter(Boolean)

/**
 * Check if a user is an admin
 * @param user - The user object to check
 * @returns true if the user is an admin, false otherwise
 */
export const isAdmin = (user: User | null): boolean => {
  if (!user || !user.email) {
    return false
  }

  // Check if user email is in the admin list (case-insensitive)
  return ADMIN_EMAILS.includes(user.email.toLowerCase().trim())
}

/**
 * Get admin emails (for debugging purposes only)
 * @returns Array of admin email addresses
 */
export const getAdminEmails = (): string[] => {
  return [...ADMIN_EMAILS]
}
